import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@types-lib';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';

export class RegisterTempUserEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  put(credentials: Auth.RegisterTempUserRequest) {
    return this.httpClient
      .put<Auth.RegisterTempUserResponse>(`${this.env.constants.api_url}users/temp`, credentials)
  }
}
